export const DETACHED_AUTH_APP = "detachedAuthApp";
